import React, {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import EMDBcart from  '../../utils/emdb.cart.js'

//CSS
import styles from './VTCartSummary.module.less';

function Product({product,t,i18n}) {
  let totaltamount=0.0;

  const listContents = Object.keys(product.contents).map(idcontent => {
    const amount = product.contents[idcontent].price * product.contents[idcontent].numberItems - product.contents[idcontent].discount;
    totaltamount += amount;
    return (
      <div key={product.contents[idcontent].id}className={styles.content}>
        <div className={styles.pax}>
          {product.contents[idcontent].numberItems} x {product.contents[idcontent].description[i18n.language] ? product.contents[idcontent].description[i18n.language]:product.contents[idcontent].description['es']} ({product.contents[idcontent].price.toFixed(2)} &euro;)
        </div>
        <div className={styles.paxprice}>{amount.toFixed(2)} &euro;</div>
      </div>
    );
  });

  return (
    <div className={styles.summaryItem}>
      <div className={styles.title}>{product.name[i18n.language] ? product.name[i18n.language]:product.name['es']}</div>
      <div className={styles.date}>{t('Fecha')}: {product.date }</div>
      <div className={styles.contents}>
        {listContents}
      </div>
      <div className={styles.line}></div>
      <div className={styles.total}>{totaltamount.toFixed(2)} &euro;</div>
    </div>
  );
}

function VTCartSummary({config}) {

  const [cart, setCart] = useState(new EMDBcart('vtformcart'));
  const {t,i18n} = useTranslation(["vtcartsummary"]);
  const language = (config.hasOwnProperty('locale')) ? config.locale : 'es';

  const productsCart=cart.getCartProducts();
  const numProductsCart=cart.getNumProducts();
  const amountCart=cart.getCartAmount();
  const discountbypromotions=0;
  const total=amountCart-discountbypromotions;
  let listProducts;

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language]);

  useEffect(() => {
    //Comprobamos evento Storage para saber si se actualizo el carro
    const handleStorage = () => {
      //Actualizamos el objeto con el carro
      setCart(new EMDBcart('vtformcart'));
    }
    document.addEventListener('storage', handleStorage)
    return () => document.removeEventListener('storage', handleStorage)
  }, [])


  if (numProductsCart > 0 ){
    listProducts = Object.keys(productsCart).map(idproduct =>{
      return <Product key={productsCart[idproduct].id} product={productsCart[idproduct]} t={t} i18n={i18n}/>;
    });
  }else{
    listProducts =
      <div className={styles.cartEmpty}>
        {t('El carro de la compra esta vacio')}
      </div>
  }

  return (
    <div className={styles.cartSummary}>
      <div className={styles.header}>
        <h3>{t('Resumen de compra')}</h3>
      </div>

      <div className={styles.summaryItems}>
        {listProducts}
      </div>

      <div className={styles.summaryTotals}>
        <div className={styles.content}>
          <div className={styles.text}>{t('Subtotal')}:</div>
          <div className={styles.price}>{amountCart.toFixed(2)} &euro;</div>
        </div>

        <div className={styles.content}>
          <div className={styles.text}>{t('Gastos de gestión')}:</div>
          <div className={styles.price}>0.00 &euro;</div>
        </div>

        <div className={styles.content}>
          <div className={styles.text}>{t('Descuento')}:</div>
          <div className={styles.price}>0.00 &euro;</div>
        </div>

        <div className={styles.line}></div>

        <div className={styles.content}>
          <div className={styles.text}>{t('Precio total')}:</div>
          <div className={styles.price}>{total.toFixed(2)} &euro;</div>
        </div>
      </div>
    </div>
  );
}
export default VTCartSummary;